export interface SpecItem {
  label: string
  value: string
  unit?: string
}

/** Spec sheet: 2/4-up hairline table; the following section's top rule closes it. */
export function ModelDetailSpecStrip({ items }: { items: Array<SpecItem> }) {
  if (items.length === 0) return null

  return (
    <dl className="grid grid-cols-2 border-t border-[var(--color-border)] sm:grid-cols-4">
      {items.map((item, i) => (
        <div
          key={item.label}
          className={[
            'min-w-0 py-5 pr-4',
            i % 2 === 1 ? 'border-l border-[var(--color-border)] pl-4 sm:pl-5' : '',
            i >= 2 ? 'border-t border-[var(--color-border)] sm:border-t-0' : '',
            i >= 2 && i % 2 === 0 ? 'sm:border-l sm:pl-5' : '',
          ].join(' ')}
        >
          <dt className="eyebrow truncate text-[0.6875rem]">{item.label}</dt>
          <dd className="mt-2 truncate font-mono text-title-sm tabular-nums text-[var(--color-text-primary)]">
            {item.value}
            {item.unit && (
              <span className="ml-1.5 text-caption text-[var(--color-text-tertiary)]">
                {item.unit}
              </span>
            )}
          </dd>
        </div>
      ))}
    </dl>
  )
}
